<template>
    <div class="step-indicator">
      <div
        v-for="(step, index) in steps"
        :key="index"
        class="step"
        :class="{
          'active': index === currentStep,
          'completed': index <= currentStep
        }"
      >
        <div class="circle">{{ index + 1 }}</div>
        <div class="label">{{ step }}</div>
        <div v-if="index < steps.length -1 " class="line"></div>
      </div>
    </div>
  </template>

  
<script>
export default {
  props: {
    steps: {
      type: Array,
      required: true,
    },
    currentStep: {
      type: Number,
      default: 1,
    },
  },
};
</script>

<style>
.step-indicator {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  direction: rtl;
  background-color: rgb(1 1 1 / 15%);

}

.step {
  display: flex;
  align-items: center;
  position: relative;
  flex: 1;
}

.circle {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color:#ffffff; 
  /* lightgray; */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.active .circle {
  background-color: #007bff;
  color: #fff;
}

.completed .circle {
  background-color: #28a745;
  color: #fff;
}

.label {
  margin-left: 8px;
  margin-top: 20px;
}

.line {
  position: absolute;
  top: 15px;
  /* right: -50%; */
  right:0%;
  width: 100%;
  height: 2px;
  background-color: lightgray;
  z-index: -1;

}

.step.active + .step .line,
.step.completed + .step .line {
  /* background-color: #007bff; */
}
</style>